<template>
  <div class="cover-layer">
    <div class="position">
      <div class="position-hd">
        <span>位置信息</span>
        <svg-icon
          icon-class="close"
          class="position-hd-close cur-pointer"
          @click="$emit('input', false)"
        />
      </div>
      <div class="position-bd">
        <div id="MAP" class="position-address"></div>
      </div>
    </div>
  </div>
</template>

<script>
let LOCATION_ICON = `<svg t="1599708351202" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1323" width="30" height="30">
                        <path d="M698.981453 181.327103c-136.411491-141.543848-357.561468-141.543848-493.972959 0-136.411491 141.565687-136.411491 371.102154 0 512.646002l246.98648 254.870653 246.986479-254.870653c136.411491-141.543848 136.411491-371.080314 0-512.646002zM451.994974 533.843574a109.17724 109.17724 0 0 1-109.155401-109.22092 109.19908 109.19908 0 0 1 109.155401-109.22092 109.19908 109.19908 0 0 1 109.1554 109.22092 109.19908 109.19908 0 0 1-109.1554 109.22092z" p-id="1324" data-spm-anchor-id="a313x.7781069.0.i4" class="selected" fill="#d81e06"></path>
                      </svg>`

export default {
  props: {
    type: {
      type: String,
      default: 'merchant',
      comment: '显示商户的还是供应商的地址信息'
    },
    value: Boolean,
    details: Object,
    defaultAddress: Number
  },

  data() {
    return {
      mapInstance: null
    }
  },

  computed: {
    address() {
      const { details } = this

      // 商户
      if (this.type === 'merchant') {
        return [
          {
            name: '注册地址',
            lat: details.merPermitLatitude || 0,
            long: details.merPermitLongitude || 0
          },
          {
            name: '实际经营地址',
            lat: details.merLatitude || 0,
            long: details.merLongitude || 0
          },
          {
            name: '家庭地址',
            lat: details.corpHomeLatitude || 0,
            long: details.corpHomeLongitude || 0
          },
          {
            name: '进件地址',
            lat: details.entryLatitude || 0,
            long: details.entryLongitude || 0
          },
          {
            name: '身份证地址',
            lat: details.corpCertLatitude || 0,
            long: details.corpCertLongitude || 0
          }
        ]
        // 供应商
      } else if (this.type === 'supplier') {
        return [
          {
            name: '注册地址',
            lat: details.registerAddressLatitude || 0,
            long: details.registerAddressLongitude || 0
          },
          {
            name: '实际经营地址',
            lat: details.realMapLa || 0,
            long: details.realMapLo || 0
          },

          {
            name: '家庭地址',
            lat: details.homeAddrLongitude || 0,
            long: details.homeAddressLatitude || 0
          },
          {
            name: '进件地址',
            lat: details.entryLatitude || 0,
            long: details.entryLongitude || 0
          },
          {
            name: '身份证地址',
            lat: details.certAddressLatitude || 0,
            long: details.certAddressLongitude || 0
          }
        ]
      }
    }
  },

  mounted() {
    this.initSetMap()
  },

  methods: {
    initSetMap() {
      let centerNum = this.details.opertionNum || 0
      // console.log(this.details.opertionNum, this.address[centerNum])
      // debugger
      const MAP_MOUNTE = document.querySelector('#MAP')
      const MAP_INSTANCE = new AMap.Map(MAP_MOUNTE, {
        mapStyle: 'amap://styles/9a9fa2e5921eb74e7746723fc529485d', // 自定义地图样式
        center: [this.address[centerNum].long, this.address[centerNum].lat], //设置地图中心点坐标
        lang: 'zh_cn', //设置地图语言类型
        zoom: 12 //设置地图显示的缩放级别
      })

      this.address.forEach(point => {
        let temp1 = LOCATION_ICON.lastIndexOf('fill="') + 6
        let temp2 = LOCATION_ICON.substring(temp1, temp1 + 7)
        let color = '#3f67f5'
        if (point.name == '注册地址') {
          color = '#3f67f5'
          LOCATION_ICON = LOCATION_ICON.replace(temp2, '#3f67f5')
        } else if (point.name == '实际经营地址') {
          color = '#f13a30'
          LOCATION_ICON = LOCATION_ICON.replace(temp2, '#f13a30')
        } else if (point.name == '家庭地址') {
          color = '#fca75c'
          LOCATION_ICON = LOCATION_ICON.replace(temp2, '#fca75c')
        } else if (point.name == '进件地址') {
          color = '#6bd9ab'
          LOCATION_ICON = LOCATION_ICON.replace(temp2, '#6bd9ab')
        } else if (point.name == '身份证地址') {
          color = '#3f67f5'
          LOCATION_ICON = LOCATION_ICON.replace(temp2, '#3f67f5')
        }
        // console.log(point.name, point.long, point.lat)
        MAP_INSTANCE.add(
          new AMap.Marker({
            position: new AMap.LngLat(point.long, point.lat),
            content: `${LOCATION_ICON}<span style="color:${color};font-weight: 800;display: block; width: 200px;">${point.name}</span>`,
            zIndex: 1
          })
        )
      })

      this.mapInstance = MAP_INSTANCE
    }
  }
}
</script>

<style lang="scss" scoped>
.cover-layer {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
  background: rgba($color: #000, $alpha: 0.5);
  z-index: 98;
}

.position {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 1100px;
  height: 650px;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;

  &-hd {
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    background: #f1f3f6;
    color: #212832;

    &-close {
      position: absolute;
      right: 20px;
      top: 14px;
      width: 25px;
      height: 25px;
    }
  }

  &-bd {
    height: 600px;

    .position-address {
      height: 620px;
    }
  }
}
</style>
